import React, {useEffect, useState} from 'react'
import Draggable from 'blocks.simple/draggable/draggable'
import Icon from 'blocks.simple/icon/icon'
import helpers from 'core/helpers'
import { jsUcfirst } from '../line.utils'
import { cn } from 'ethcss'
import styles, { iconSize } from './line_h.jcss'
import { indents } from 'blocks.app/config'
import { grid } from '../../../theme'
import { defaultThemeStyles } from '../line.theme'

interface ILineH {
    scaleLength: number
    steps: number
    smallStepsPosition: string
    indents: string
    position: string
    showLastStep: boolean
    showMovablePoint: boolean
    size: number
    onMouseDown: () => void
}

const LineH = (p_: ILineH) => {
    const [state, setState] = useState({
        steps: calcSteps(p_),
    })
    const [prevProps, setPrevProps] = useState<ILineH | null>(null)

    useEffect(() => {
        if(JSON.stringify(p_) !== JSON.stringify(prevProps)){
            setState({
                steps: calcSteps(p_)
            })
            setPrevProps(p_)
        }
    }, [p_])

    function calcSteps (p_: ILineH) {
        const steps = Math.round((p_.size / 100) * p_.steps)

        return helpers.calcScaleSteps(p_.scaleLength, steps)
    }

    const smallNumber = 5
    const smallWidth = `${100 / smallNumber}%`

    return (
        <div
            className={cn(styles.wrapper)}
            style={{
                left: indents[p_.indents],
                right: indents[p_.indents],
                [p_.position]: 0,
                [`border${jsUcfirst(
                    p_.smallStepsPosition
                )}`]: `2px solid var(--var-module-ui-component-line-style-outerBorder, ${defaultThemeStyles.outerBorder})`,
            }}
            onMouseDown={p_.onMouseDown}
        >
            <div className={styles.innerContent} style={{ width: `${p_.size}%` }}>
                {state.steps.map((step, index) => (
                    <div
                        style={{ width: `${step.width}%` }}
                        key={`lineH_${p_.smallStepsPosition}_${index}`}
                        className={cn(styles.item, { [styles.itemLast]: !p_.showLastStep })}
                    >
                        <div className={styles.itemNumber}>{step.number}</div>
                        <div style={{ [p_.smallStepsPosition]: 0 }} className={styles.smallSteps}>
                            {(() => {
                                const smallSteps = []
                                for (let i = 0; i < smallNumber - 1; i++) {
                                    smallSteps.push(
                                        <div
                                            style={{ width: smallWidth }}
                                            key={`lineH_${p_.smallStepsPosition}_${index}_${i}`}
                                            className={styles.smallStep}
                                        />
                                    )
                                }

                                return smallSteps
                            })()}
                        </div>
                    </div>
                ))}
                {p_.showLastStep && (
                    <div
                        className={styles.item}
                        style={{
                            position: 'absolute',
                            right: `-${indents[p_.indents]}px`,
                            width: `${indents[p_.indents]}px`,
                        }}
                    >
                        <div className={styles.itemNumber}>{p_.scaleLength}</div>
                    </div>
                )}
                {p_.showMovablePoint && (
                    <Draggable
                        left={0}
                        top={0}
                        height={1}
                        width={0}
                        disableResize={true}
                        noBorder={true}
                        isDraggable={true}
                    >
                        <div className={styles.arrow}>
                            <div className={grid.space} />
                            <Icon size={iconSize} color={'white'} type={'arrowhead_down'} />
                        </div>
                    </Draggable>
                )}
            </div>
        </div>
    )
}

LineH.defaultProps = {
    steps: 20,
    scaleLength: 1920,
    smallStepsPosition: 'bottom',
    indents: 'mdPlus',
    position: 'top',
    size: 100,
    showMovablePoint: false,
}

export default LineH
